import jwtDecode from "jwt-decode";

// This is the email of the admin user.
// You should replace this with your own admin's Google account email.
const ADMIN_EMAIL = "dmoore2000@gmail.com";

const getAuthToken = () => {
  return localStorage.getItem('authToken');
}

const Headers = () => {
  const token = getAuthToken();
  if (!token) {
    // This will likely cause API calls to fail, which is expected if the user is not logged in.
    console.warn("Authentication token not found.");
    return { "Content-Type": "application/json" };
  }
  return { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
}

export function isUserAdmin() {
  const userProfile = localStorage.getItem('userProfile');
  if (!userProfile) {
    return false;
  }
  const profile = JSON.parse(userProfile);
  const isAdmin = profile.email === ADMIN_EMAIL;
  console.log(`Is user admin? ${isAdmin}`);
  return isAdmin;
}

async function makeApiRequest(path, method = 'GET', body = null) {
  // In a React app, it's common to have the API server on the same host,
  // so we can use a relative path.
  const apiUrl = `${window.location.origin}${path}`;
  console.log(`Making API request to: ${apiUrl}`);

  const options = {
    method,
    headers: Headers(),
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(apiUrl, options);
    if (response.status === 401) {
      window.dispatchEvent(new CustomEvent('unauthorized'));
    }
    if (!response.ok) {
      // Throw an error with the status to be caught by the caller
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return { status: response.status, data };
  } catch (err) {
    console.error("API request failed:", err);
    // Re-throw the error so the calling function can handle it
    throw err;
  }
}

export async function APIGetMaxYear() {
  const path = `/api/max-year`;
  return makeApiRequest(path, 'GET');
}

export async function APIGet(searchTerm) {
  const query = new URLSearchParams(searchTerm).toString();
  const path = `/api/files?${query}`;
  return makeApiRequest(path, 'GET');
}

export async function APIPost(body) {
  const path = '/api/files';
  return makeApiRequest(path, 'POST', body);
}

export async function doUpdateImgData(fullPath, fileName, caption, notes, keywords, fileDate) {
  let body = { fullPath, fileName, caption, notes, keywords, fileDate: fileDate.valueOf() }
  try {
    console.log(body);
    let response = await APIPost(body)
    console.log(`doUpdateImgData: ${response}`)
    return response.status === 200;
  } catch (e) {
    console.log(`doUpdateImgData catch: ${e}`)
    alert(`Error when updating metadate: ${e}`)
    return false;
  }
}

export async function doUploadImg(image, thumb, caption, notes, keywords, fileDate) {
  alert("File upload is not implemented in this version.");
  console.error("doUploadImg is called, but it relies on AWS S3 storage which has been removed.");
  return false;
  // The original logic was tied to AWS Amplify's Storage module.
  // This needs to be replaced with a new upload flow, for example:
  // 1. Request a signed URL from your backend.
  // 2. Use the signed URL to upload the file directly to Google Cloud Storage.
  // 3. After the upload is complete, notify your backend.
}


export async function searchArtworks(searchTerm) {
  let { keyword, next, asc, from, to, exact_match } = searchTerm;
  let isAsc = asc != "false";
  console.log(from)
  let aFrom = from ?? null;
  let aTo = to ?? null;
  try {
    const query = { keywords: keyword, next, "asc": isAsc, exact_match: exact_match !== false };
    if (aFrom !== null) {
      query.start_date = new Date(aFrom).toISOString();
    }
    if (aTo !== null) {
      query.end_date = new Date(aTo).toISOString();
    }
    let response = await APIGet(query);

    response.data.files.forEach((pic) => {
        pic.image_url = pic.download_url;
        pic.thumbnail = pic.thumbnail_url
      });

    response.data.data = response.data.files;
    response.data.length = response.data.files.length;

    return response.data;
  }
  catch (err) {
    console.log(err);
  };
}

// The functions below were not implemented in the original file and are left as is.
export async function tagImage(image, keywords) {
  console.log("tagImage not implemented");
  return "";
}

export async function getKeywords() {
  console.log("getKeywords not implemented");
  return [];
}
